import { useMemo } from "react";

import { useStore } from "@nanostores/react";
import {
  $featureFlagOverrides,
  clearAllOverrides,
  clearOverride,
  NON_OVERRIDABLE_FLAGS,
  setAllOverrides,
  setOverride,
} from "@vega-api/extended/auth/featureFlagOverrides";
import {
  featureFlagKeys,
  useFeatureFlag,
} from "@vega-api/extended/auth/useFeatureFlag";

import { OverridePanel } from "./OverridePanel";

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

export function FeatureFlagPanel({ isOpen, onClose }: Props) {
  // Avoid the @nanostores subscription and the FF query when the panel is closed
  // — the parent palette mounts this unconditionally.
  if (!isOpen) return null;

  return <FeatureFlagPanelContent onClose={onClose} />;
}

function FeatureFlagPanelContent({ onClose }: { onClose: () => void }) {
  const overrides = useStore($featureFlagOverrides);
  const { featureFlag } = useFeatureFlag();

  const overridableKeys = useMemo(
    () => featureFlagKeys.filter((key) => !NON_OVERRIDABLE_FLAGS.has(key)),
    [],
  );

  return (
    <OverridePanel
      dataTestIdPrefix="feature-flag"
      effectiveValues={featureFlag}
      keys={overridableKeys}
      onClearAll={clearAllOverrides}
      onClearOverride={clearOverride}
      onClose={onClose}
      onSetAll={(value) => setAllOverrides(overridableKeys, value)}
      onSetOverride={setOverride}
      overrides={overrides}
      title="Feature Flags"
    />
  );
}
